import { useSelector } from 'react-redux'
import { API_TIER_4_ENTERPRISE } from 'constants/public_api'

export const useApiSubscription = () => {
  const jsSubscriptionCurrency =
    useSelector(
      state => state.globalData?.membershipInfo?.stripe_plan?.currency
    ) || 'usd'

  const apiSubscription = useSelector(state => state.globalData.apiSubscription)
  const apiTier = apiSubscription?.tier || null
  const billingPeriodStart = apiSubscription?.current_period_start || null
  const billingPeriodEnd = apiSubscription?.current_period_end || null

  const { requestCount, limit } = useSelector(state => state.account.apiKeys)

  const isLimitReached = requestCount >= limit
  const isOverLimit = requestCount > limit
  const isFreeTier = !apiTier && limit > 0
  const isEnterpriseApiTier = apiTier === API_TIER_4_ENTERPRISE

  return {
    apiTier,
    isFreeTier,
    isEnterpriseApiTier,
    requestCount,
    billingPeriodStart,
    billingPeriodEnd,
    isLimitReached,
    isOverLimit,
    limit,
    jsSubscriptionCurrency
  }
}
